import React, {
  FC, useEffect, useState,
} from 'react';
import {
  BackgroundImage,
  Button,
} from './Styles';
import Header from '../../../../../Common/Header';
import { Box, Cab } from '../../../../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import Logo from '../../../../../Common/Logo';
import Location from '../../../../../Common/Location';
import PickupCode from '../../../../../Common/PickupCode';

const ReopenBox: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  cab,
  setPickupCode,
  selectedPlatform,
  setSelectedPlatform,
  setOpenedBoxes,
}) => {
  const [reopenBoxLazy, { loading: reopenLoading }] = updateFoodifoxData<Box[]>('/foxH5Driver/reopenOrderBoxByCode');
  const [checkPickupCodeLazy, { loading: checkCodeLoading }] = getFoodifoxDataLazy<string>('/foxH5Check/checkPickupCodeIsValid');

  const [codeNum, setCodeNum] = useState<string>();
  const [codeIsChecked, setCodeIsChecked] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(checkCodeLoading || reopenLoading);

    return () => {
      setShowLoading(false);
    };
  }, [checkCodeLoading, reopenLoading]);

  /**
   * 重新开柜门
   */
  const reopenBox = () => {
    if (!codeNum) {
      return;
    }

    reopenBoxLazy({
      param: {
        cabId: cabId32Str,
        openCode: codeNum,
        platform: selectedPlatform,
      },
      onCompleted(boxes) {
        setPickupCode(codeNum);
        setOpenedBoxes(boxes);
        setTargetPage('reopen-box-success');
      },
    });
  };

  return (
    <BackgroundImage>
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      {/* Logo */}
      <Logo clearPlatform={setSelectedPlatform} setTargetPage={setTargetPage} backToPage={'platform-select-reopen-box'} />

      {/* 地点 */}
      <Location isEnglish={isEnglish} cab={cab} />

      {/* 描述 */}
      <div style={{ marginTop: '40px', width: '314px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
        {
          isEnglish ? (
            <div style={{ fontSize: '16px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '25px' }}>
              Please enter the <span style={{ fontFamily: 'Squad-Bold', fontSize: '16px' }}>Pickup Code</span>
            </div>
          ) : (
            <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-Bold, PingFang SC', fontWeight: 'bold', color: '#11202B', lineHeight: '25px' }}>
              请输入取餐码
            </div>
          )
        }
      </div>

      {/* 取餐码 */}
      <div style={{ marginTop: '47px', width: '314px', padding: '0 19px', marginLeft: 'auto', marginRight: 'auto' }}>
        <PickupCode
          style={{ marginTop: '10px' }}
          callback={(pickupCode) => {
            setCodeNum(pickupCode);
            checkPickupCodeLazy({
              param: {
                cabId: cabId32Str,
                pickupCode,
                platform: selectedPlatform,
              },
              onCompleted() {
                setCodeIsChecked(true);
              },
            });
          }}
        />
      </div>

      {/* 打开柜门按钮 */}
      <Button
        disabled={!codeIsChecked}
        onClick={() => reopenBox()}
        style={{ width: '114px', height: '114px', borderRadius: '50%', border: codeIsChecked ? '2px solid #11202B' : undefined, background: codeIsChecked ? '#01B596' : '#D0D0D0', marginLeft: 'auto', marginRight: 'auto', marginTop: '50px' }}
      >
        {
          isEnglish ? (
            <div style={{ fontSize: '25px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '33px' }}>
              Reopen
            </div>
          ) : (
            <div style={{ fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '30px' }}>
              重新
              <br />
              开柜
            </div>
          )
        }
      </Button>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  cab: Cab,
  setPickupCode: (code: string) => void;
  selectedPlatform: number;
  setSelectedPlatform: (platform?: number) => void;
  setOpenedBoxes: (openedBoxes: Box[]) => void;
}

export default ReopenBox;
